import { Component, OnInit, OnDestroy, Input, Output,EventEmitter } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';

import { TransferService } from '@plugins/share_transfer/src/App/services/transfer.service';

@Component({
    selector: 'share-transfer-select-files-section',
    templateUrl: './select-files.component.html',
    styleUrls: ['./select-files.component.scss']
})
export class PluginShareTransferSelectFilesSectionComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;
    public readonly NOT_FOUND = 3;

    public readonly SELECTION_MODE_NONE = 0;
    public readonly SELECTION_MODE_FILE = 1;
    public readonly SELECTION_MODE_VERSION = 2;

    public pageStatus: number = this.LOADING;
    public version: Objects.Version;
    public filesUrl: string = "";
    public selectionMode: number = this.SELECTION_MODE_NONE;

    @Input() project: Objects.Request;
    @Input() requestHeader: Objects.BasicRequest;
    @Input() files: Array<Objects.AmsFile> = [];

    @Output() selectedChange = new EventEmitter<Array<Objects.AmsFile>>()

    public subs = new Subscription();

    constructor(private http: HttpClient, 
        public urlSrv: UrlService,
        private activeRoute: ActivatedRoute,
        private transferSrv: TransferService
     ){}


    ngOnInit() {
        // load query params
        this.subs.add(
            this.activeRoute.queryParams.subscribe(params => {
                if ( params.version ) {
                    this.loadVersion(Number(params.version));
                    this.selectionMode = this.SELECTION_MODE_VERSION;
                } 
                if (params.file ) {
                    this.selectionMode = this.SELECTION_MODE_FILE;
                }
            })
        );

        if(this.project != null){
            this.filesUrl = "/projects/" + this.project.id +"/attachments";
        }

    }

    ngOnDestroy(){
        this.subs.unsubscribe();
    }
    onChange(e: Array<Objects.AmsFile>) {
        // console.log(" cambia  ",e);
        this.setSelected(e);
        this.selectedChange.emit(this.files);
    }

    onRemove(e: Objects.AmsFile) {
        let fileId = e.id;
        let files = this.files.filter(f => f.id != fileId);
        this.setSelected(files);
        this.selectedChange.emit(this.files);

    }

    setSelected(files: Array<Objects.AmsFile>){
        this.files = files;
    }

    private loadVersion(versionId: number) {
        // this.http.get(this.urlSrv.build("/versions/" + versionId)).subscribe({
        this.subs.add(
            this.transferSrv.loadVersion(versionId).subscribe({
            next: (data: Objects.Version) => {
                    this.version = data;
                    this.pageStatus = this.DONE;
                },
                error: (error:any) => {
                    this.pageStatus = this.ERROR;
                }
            })
        );
    }

}
